export default {
  // 获取问卷详情
  getQuestionnaireDetail: '/amc/client/getQuestionnaireDetail',
  // 获取问卷详情 H5
  getQuestionnaireDetailForH5: '/amc/client/getQuestionnaireDetailForH5',
  // 获取问卷题目
  getQuestionnaireSubjects: '/amc/client/getQuestionnaireSubjects',
  // 保存答卷
  addQuestionAnswer: '/amc/client/addQuestionAnswer'
}